import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../../features/external-api/redux/actions';
import * as commonActions from '../../../features/common/redux/actions';
import ExternalApiHeaderNav from '../ExternalApiHeaderNav';
import ParentDocCard from '../../common/ParentDocCard';
import ParentContentCard from '../../common/ParentContentCard';
import { CHAT_GPT } from 'drapcode-constant';
import { checkToShowSaveBtn } from '../../plugin/utils';
import { parseExtractPluginCode } from '../../../common/utils/plugin_utils';
import RestApiInfo from '../rest-api/RestApiInfo';
import { ChatGptForm } from './ChatGptForm';
import CustomLoader from '../../common/CustomLoader';
import { checkChatGPTPermission } from '../../../common/utils/permissions';
import PermissionDenied from '../../../common/PermissionDenied';

export class ChatGptEdit extends Component {
  static propTypes = {
    externalapi: PropTypes.object.isRequired,
    home: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = { dataTypes: [] };
  componentDidMount = async () => {
    const { match, actions, commonActions } = this.props;
    const { projectId, version, externalApiId } = match.params;
    await actions.loadCollections({ projectId, version });
    await actions.loadExternalDatabase({ projectId, version });
    await commonActions.loadProjectDetail({ projectId, version });
    const extenalData = this.props.externalapi.externalDatabase;
    if (extenalData) {
      const dataTypes = [...new Set(extenalData.map((item) => item.type))];
      this.setState({ dataTypes });
    }
    if (externalApiId) {
      const { loadExternalApi } = actions;
      loadExternalApi({ externalApiId, projectId, version });
    }
  };

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    const { home: nextHome } = nextProps;
    const { home } = this.props;
    const { iPlugins: nextIPlugins } = nextHome;
    if (!nextIPlugins || nextIPlugins.length === 0) {
      return true;
    }
    const { iPlugins } = home;
    if (!checkToShowSaveBtn(nextIPlugins, iPlugins)) {
      const dataTypes = parseExtractPluginCode(nextIPlugins, 'EXTERNALAPI');
      this.setState({ dataTypes });
    }
    return true;
  }

  render() {
    const isAllowed = checkChatGPTPermission();
    if (!isAllowed) {
      return <PermissionDenied message="Chat GPT APIs" />;
    }
    const { match, home, common, externalapi, actions, history } = this.props;
    const { collections, externalApiData, loadExternalApiPending } = externalapi;
    const { projectId, version, externalApiId } = match.params;
    const { dataTypes } = this.state;
    const { iPlugins } = home;
    const { projectDetail } = common;

    if (externalApiId && loadExternalApiPending) {
      return (
        <div className="text-center">
          <CustomLoader loading={loadExternalApiPending} size="20px" color="#303453" />
        </div>
      );
    }

    return (
      <div className="main">
        <div className="section">
          <div className="container externalapi">
            <ExternalApiHeaderNav
              version={version}
              activeTab={CHAT_GPT}
              projectId={projectId}
              headers={dataTypes}
            />
            <div className="row mx-auto">
              <ParentContentCard
                icon={CHAT_GPT}
                title={`${externalApiId ? 'Update' : 'Create'} ChatGPT Prompt`}
              >
                <RestApiInfo version={version} projectId={projectId} />
                <ChatGptForm
                  actions={actions}
                  projectId={projectId}
                  version={version}
                  externalApiId={externalApiId}
                  externalApiData={externalApiData}
                  externalapi={externalapi}
                  collections={collections}
                  iPlugins={iPlugins}
                  history={history}
                  projectDetail={projectDetail}
                />
              </ParentContentCard>
              <ParentDocCard>
                <h5>
                  <b>About ChatGPT API</b>
                </h5>
                <p>
                  DrapCode supports ChatGPT to send or process data using ChatGPT API integration.
                </p>
                <br />
              </ParentDocCard>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    externalapi: state.externalapi,
    home: state.home,
    common: state.common,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
    commonActions: bindActionCreators({ ...commonActions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ChatGptEdit);
